import translations from './translations.js';

export default (
  twoFactorRequired,
  language = 'en_US',
  {
    useForRecovery,
  } = {}
) => {
  let data = {
    title: translations(`title${useForRecovery ? 'ForRecovery' : ''}`, language),
    submitText: translations('submitText', language),
    showCancelButton: !twoFactorRequired,
    canClose: !twoFactorRequired,
    cancelText: translations('cancelText', language),
  };
  return data;
};
